import { render, staticRenderFns } from "./NotAllowedComponent.vue?vue&type=template&id=9ad7a316&scoped=true"
import script from "./NotAllowedComponent.vue?vue&type=script&lang=ts"
export * from "./NotAllowedComponent.vue?vue&type=script&lang=ts"
import style0 from "./NotAllowedComponent.vue?vue&type=style&index=0&id=9ad7a316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad7a316",
  null
  
)

export default component.exports